import "./App.css";
import { BrowserRouter } from "react-router-dom";
import { UserContextProvider } from "./auth/userContext";
import { AdminAuthProvider } from "./admin/AdminAuthContext";
import ContentLayout from "./ContentLayout";

function App(appProps) {
  return (
    <UserContextProvider>
      <AdminAuthProvider>
        <BrowserRouter>
          <ContentLayout {...appProps} />
        </BrowserRouter>
      </AdminAuthProvider>
    </UserContextProvider>
  );
}

export default App;
